<template>
	<div class="main-news-2_block">
		<div class="wrapper">
			<div class="news_content">
				<div class="main-news-2 __col-3">
					<div class="main-news-2_title-row">
						<h1 class="main-news-2_title">Новости</h1>
					</div>
						
					<sport-categories @update="updateSport" :sport="sport"></sport-categories>
					
					<div class="main-news-2_items" v-if="items.length">
						<div class="main-news-2_item" v-for="newsItem in items" :key="newsItem.id">
							<router-link :to="{ name: 'news-item', params: { id: newsItem.id } }">
								{{ newsItem.title }}
							</router-link>
							<div class="news_bottom">
								<div class="news_info">
									{{ getTime(newsItem.pub_date) }}
								</div>
							</div>
						</div>
					</div>
					
					<div v-else>
						<div class="info-text" v-if="gotData">Новостей нет</div>
						<div class="info-text" v-else style="padding-top: 20px;">Загружается...</div>
					</div>
					
					<paginate v-if="count" @page-changed="updateData" :total="count" :limit="limit"></paginate>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	
	import Paginate from "../components/Pagination/Paginate";
	import SportCategories from "../components/News/SportCategories";
	
	
	export default {
		components: {
			Paginate,
			SportCategories
		},
		
		data() {
			return {
				sport: this.$route.query.sport,
				page: Number(this.$route.query.page) || 1,
				items: [],
				limit: 9,
				count: 0,
				gotData: false
			}
		},
		
		mounted() {
			$('select').select2({
				minimumResultsForSearch: -1
			});
		},
		
		created() {
			this.initNews();
		},
		
		methods: {
			initNews() {
				let params = {
					sport: this.sport,
					limit: this.limit,
					page: this.page
				};
				
				this.axios.get('/api/news', {params: params})
					.then(({data}) => {
						this.items = data.data;
						this.count = data.count;
						this.gotData = true;
					});
			},
			getTime(time) {
				return moment(time).locale('ru').format('D MMMM Y, HH:mm')
			},
			
			updateData(page) {
				this.page = page;
				
				this.$router.push({
					name: 'news',
					query: {
						page: page,
						sport: this.sport
					}
				});
			},
			updateSport(sport) {
				this.sport = sport;
				
				this.updateData(1);
			}
		}
	}
</script>

<style scoped>

</style>